import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { baseUrl } from '@finnairoyj/fcom-ui-styles';

import { TableComponent } from './table.component';
import { IconsModule } from '../icons/icons.module';
import { PaginationModule } from '../pagination/pagination.module';
import { LoaderModule } from '../loader/loader.module';

@NgModule({
  declarations: [TableComponent],
  imports: [CommonModule, IconsModule.forRoot({ baseUrl }), PaginationModule, LoaderModule],
  exports: [TableComponent],
})
export class TableModule {}
